// authService.js
import firebaseApp from "../config/firebase";
import requestApi from "../apirest";

export const auth = firebaseApp.auth();

export async function getUserByUid(uid, email) {
  try {
    const response = await requestApi(
      "/users/findById",
      { idAuth: uid },
      "get",
      "user"
    );

    const user = response?.data?.doc;

    if (!user) {
      if (process.env.NODE_ENV === "development") {
        return { uid, email, role: "admin" };
      }
      return null;
    }

    return user;
  } catch (error) {
    return null;
  }
}

export async function login({ email, password }) {
  try {
    const authResult = await auth.signInWithEmailAndPassword(email, password);

    if (!authResult.user) return null;

    const user = await getUserByUid(authResult.user.uid, authResult.user.email);

    if (!user) {
      await auth.signOut();
      return null;
    }

    return user;
  } catch (error) {
    return null;
  }
}
